<div *ngIf="redirect" class="modal-header">
    <h2 class="modal-title">{{ 'requests.entry.modalTitle' | translate }}</h2>
    <button type="button" class="btn-close" aria-label="Close" (click)="closeModal()">
    </button>
</div>

<div [ngClass]="redirect ? 'modal-body' : 'request-entry-container'">
    <div *ngIf="!redirect" class="page-header-container">
        <div class="page-title">
            {{'requests.entry.title' | translate}}
        </div>
    </div>

    <div class="row justify-content-center"> 
        <div *ngFor="let requestType of dictionaryRequestTypes" 
            class="col-12 col-xl-6 col-xxl-4 mb-4"
            [ngClass]="{'col-xxl-4': !redirect }"
            >
            <div class="card h-100 flex-fill request-type-card" role="button" (click)="redirectRoute(requestType.redirectRoute, requestType.dictionaryRequestTypeCode)"
                [ngClass]="{
                    'selected-request-type': ((requestType.dictionaryRequestTypeCode !== RequestType.RQST_ASSET_DOCUMENT || requestAccessWarnings.length === 0 && requestType.dictionaryRequestTypeCode === RequestType.RQST_ASSET_DOCUMENT)) && requestType.redirectRoute === selectedOption && redirect, 
                    'disabled-card': requestAccessWarnings.length > 0 && requestType.dictionaryRequestTypeCode === RequestType.RQST_ASSET_DOCUMENT
                }"
                [ngbTooltip]="requestType.dictionaryRequestTypeCode === RequestType.RQST_ASSET_DOCUMENT && requestAccessWarnings.length > 0 ? warningMessagesTemplate : null" tooltipClass="request-warning-tooltip opacity-100">
                <div class="card-body d-flex flex-fill">
                    <div class="d-flex align-items-center gap-4">
                        <i class="app-icon icon icon-{{requestType.iconPath}} icon-xxxxl"></i>
                        <span class="request-type-label text-break">
                            {{requestType.dictionaryRequestTypeName}}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div *ngIf="redirect" class="modal-footer">
    <button type="button" class="btn link-btn" (click)="closeModal()">
        <i class="app-icon icon icon-return icon-lg me-2"></i> 
        {{'common.cancel' | translate}}
    </button>
    <button type="button" class="btn primary-btn" (click)="closeModal(selectedOption)">
        {{'common.confirmButton' | translate}}
    </button>
</div>

<ng-template #warningMessagesTemplate>
    <ul class="text-start ps-4 m-0">
        <li *ngFor="let message of requestAccessWarnings" [innerHtml]="message | translate"></li>
    </ul>
  </ng-template>